import './vendors/slinky.js';

export function mobileMenu() {
    //Hamburder Button
    let mobileMenuButton = $('.hamburger');
    let mobileMenuContainer = $('.mobile-menu-container');
    let siteOverlay = $('.site-overlay-dark');
    $('#mobileMenu').slinky({
        title: true
    });
    //Show/Hide Mobile Menu
    $(mobileMenuButton).on('click', function(e) {
        e.preventDefault();
        mobileMenuButton.toggleClass('is-active');
        
        if(mobileMenuContainer.hasClass('is-active')) {
            //Remove class to header when mobile menu is active
            mobileMenuContainer.slideUp(function() {
                $('header').removeClass('mobile-menu-active');
            });
            $(mobileMenuContainer).removeClass('is-active');
            $(siteOverlay).fadeOut();
        }else {
            //Opening the mobile menu closes the login panel (mutually exclusive)
            $('.olb-login').removeClass('show-login');
            //Add class to header when mobile menu is active
            $('header').addClass('mobile-menu-active');
            mobileMenuContainer.slideDown();
            $(mobileMenuContainer).addClass('is-active');
            $(siteOverlay).fadeIn();
        }

    });

    siteOverlay.on('click', function() {
        if (mobileMenuContainer.hasClass('is-active')) {
            mobileMenuButton.removeClass('is-active');
            //Remove class to header when mobile menu is active
            mobileMenuContainer.slideUp(function() {
                $('header').removeClass('mobile-menu-active');
            });
            mobileMenuContainer.removeClass('is-active');
            siteOverlay.fadeOut();
        }
    });

    //Close mobile menu on resize above desktop breakpoint
    $(window).on('resize', function() {
        if (window.innerWidth >= 1160 && mobileMenuContainer.hasClass('is-active')) {
            mobileMenuButton.removeClass('is-active');
            mobileMenuContainer.slideUp(function() {
                $('header').removeClass('mobile-menu-active');
            });
            mobileMenuContainer.removeClass('is-active');
            siteOverlay.fadeOut();
        }
    });
}